import { useState } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';

const SEARCH_RESULTS_ORIGIN_HASH_PARAM = 'clsSearchOrigin=';

const getPreservedHash = (hash) => {
  return hash?.includes(SEARCH_RESULTS_ORIGIN_HASH_PARAM) ? hash : undefined;
};

const useURL = () => {
  const history = useHistory();
  const [updateURL, setUpdateURL] = useState(false);
  const { pathname, search: currentQueryParams, hash } = useLocation();
  const params = useParams();

  const goToURL = (search) => {
    setUpdateURL(false);
    history.push({
      pathname: pathname,
      search: search,
      hash: getPreservedHash(hash),
    });
  };

  const navigateTo = (pathname, search) => {
    return history.push({
      pathname,
      search,
    });
  };

  const getValueByParamName = (paramName) => {
    const params = new URLSearchParams(currentQueryParams);
    return params.get(paramName);
  };

  const buildNewQueryParams = (newParams) => {
    const params = new URLSearchParams(currentQueryParams);

    Object.entries(newParams).forEach(([paramName, paramValue]) => {
      params.set(paramName, paramValue);
    });

    return params.toString();
  };

  const getUrlParams = (value) => params[value];

  const splitParametersIntoArray = (
    paramsReceived = currentQueryParams,
  ) => {
    const urlSearchParams = new URLSearchParams(paramsReceived);

    const objectParams = Object.fromEntries(urlSearchParams);

    return Object.entries(objectParams);
  };

  const splitParametersIntoObject = (
    paramsReceived = currentQueryParams,
  ) => {
    const urlSearchParams = new URLSearchParams(paramsReceived);
    return Object.fromEntries(urlSearchParams);
  };

  const goBack = () => {
    history.length > 2 ? history.goBack() : navigateTo('/');
  };

  return {
    splitParametersIntoArray,
    splitParametersIntoObject,
    currentQueryParams,
    goToURL,
    updateURL,
    setUpdateURL,
    getUrlParams,
    getValueByParamName,
    buildNewQueryParams,
    history,
    navigateTo,
    pathname,
    hash: getPreservedHash(hash),
    goBack,
  };
};

export default useURL;
